export function formatUsername(name: string): string {
  /**
   * На данный момент у нас бесточечная нотация
   * https://jira.interfax.ru/browse/PUB-2712
   */
  return name && name.replaceAll
    ? name.replaceAll('.', '')
    : name
}
